/**
 * ==========================================================
 * ROBAM Singapore
 * After Service Booking
 * booking.js
 * ==========================================================
 */

(function () {

    "use strict";

    console.log("booking.js loaded");

    var API_URL =
        "https://robam-booking-api.crimson-firefly-123d.workers.dev/";

    document.addEventListener("DOMContentLoaded", function () {

        var button =
            document.getElementById("btnSubmit");

        if (!button) {

            console.log("Submit button not found.");
            return;

        }

        console.log("Submit button found.");

        button.addEventListener(
            "click",
            function (e) {

                e.preventDefault();

                if (button.disabled)
                    return;

                submitBooking();

            }
        );

        // =========================================
        // Invoice Upload
        // =========================================

        var invoiceInput =
            document.getElementById("fileInvoice");

        if (invoiceInput) {

            invoiceInput.addEventListener("change", function () {

                var fileName =
                    document.getElementById("fileInvoiceName");

                if (!fileName)
                    return;

                fileName.textContent =
                    this.files.length > 0
                        ? this.files[0].name
                        : "No file selected";

            });

        }

    });

    function submitBooking() {

        console.log("Submit button clicked.");

        var invoiceInput =
            document.getElementById("fileInvoice");

        var invoiceFile =
            invoiceInput && invoiceInput.files.length > 0
                ? invoiceInput.files[0]
                : null;

        var data = {

            customerName:
                document.getElementById("txtName").value.trim(),

            contactNumber:
                document.getElementById("txtPhone").value.trim(),

            address:
                document.getElementById("txtAddress").value.trim(),

            email:
                document.getElementById("txtEmail").value.trim(),

            orderNumber:
                document.getElementById("txtOrderNumber").value.trim(),

            invoiceNumber:
                document.getElementById("txtInvoiceNumber").value.trim(),

            requestType:
                document.getElementById("ddlRequestType").value,

            preferredDate:
                document.getElementById("dtPreferredDate").value,

            preferredTime:
                document.getElementById("ddlPreferredTime").value,

            message:
                document.getElementById("txtMessage").value.trim()

        };

        console.log(data);
        console.log(invoiceFile);

        // =========================================
        // Validation
        // =========================================

        if (!data.customerName) {

            alert("Please enter your name.");
            return;

        }

        if (!data.contactNumber) {

            alert("Please enter your contact number.");
            return;

        }

        if (!data.address) {

            alert("Please enter your address.");
            return;

        }

        if (!data.email) {

            alert("Please enter your email.");
            return;

        }

        if (!data.orderNumber) {

            alert("Please enter your order number.");
            return;

        }

        if (!data.invoiceNumber) {

            alert("Please enter your invoice number.");
            return;

        }

        if (!invoiceFile) {

            alert("Please upload your invoice.");
            return;

        }

        if (!data.requestType) {

            alert("Please select a service request.");
            return;

        }

        if (!data.preferredDate) {

            alert("Please select a preferred date.");
            return;

        }

        if (!data.preferredTime) {

            alert("Please select a preferred time.");
            return;

        }

        // =========================================
        // Submit
        // =========================================

        var button =
            document.getElementById("btnSubmit");

        button.disabled = true;

        button.querySelector(".btn-text").textContent =
            "Submitting...";

        button.querySelector(".btn-spinner")
            .classList.remove("hidden");

        var xhr =
            new XMLHttpRequest();

        xhr.open(
            "POST",
            API_URL,
            true
        );

        var formData = new FormData();

        formData.append("action", "submit");

        formData.append("customerName", data.customerName);
        formData.append("contactNumber", data.contactNumber);
        formData.append("address", data.address);
        formData.append("email", data.email);

        formData.append("orderNumber", data.orderNumber);
        formData.append("invoiceNumber", data.invoiceNumber);

        formData.append("requestType", data.requestType);
        formData.append("preferredDate", data.preferredDate);
        formData.append("preferredTime", data.preferredTime);
        formData.append("message", data.message);

        if (invoiceFile) {

            formData.append(
                "invoiceFile",
                invoiceFile,
                invoiceFile.name
            );

        }

        xhr.onreadystatechange = function () {

            if (xhr.readyState !== 4)
                return;

            button.disabled = false;

            button.querySelector(".btn-text").textContent =
                "Submit Request";

            button.querySelector(".btn-spinner")
                .classList.add("hidden");

            if (xhr.status !== 200) {

                window.alert("Unable to connect to server.");
                return;

            }

            var result =
                JSON.parse(xhr.responseText);

            console.log(result);

            if (!result.success) {

                window.alert(result.message);
                return;

            }

            window.alert(
                "Booking submitted successfully.\n\nReference : " +
                result.data.bookingReference
            );

            window.location.href =
                "/pages/thank-you?reference=" +
                encodeURIComponent(
                    result.data.bookingReference
                );

        };

                xhr.send(formData);

            }

})();